import React, {useState} from 'react';
import PublicRegisterModalContent from '../components/modals/PublicRegisterModalContent';
import RegisterBoatModalContent from '../components/modals/RegisterBoatModalContent';
import RegisterAnglerModalContent from '../components/modals/RegisterAnglerModalContent';
import AdminRegistrationTabs from '../components/AdminRegistrationTabs';

function AdminRegister () {

  const [registerBoatModal, setRegisterBoatModal] = useState(false);
  const [registerTeamModal, setRegisterTeamModal] = useState(false);
  const [registerAnglerModal, setRegisterAnglerModal] = useState(false);

  const toggleTeamModal = () => {
    setRegisterTeamModal(!registerTeamModal);
  };

  const toggleBoatModal = () => {
    setRegisterBoatModal(!registerBoatModal);
  };
  
  const toggleAnglerModal = () => {
    setRegisterAnglerModal(!registerAnglerModal);
  };
  
  if(registerTeamModal || registerBoatModal || registerAnglerModal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }

  return <>

    {registerTeamModal && (
      <PublicRegisterModalContent toggleModal={toggleTeamModal} />
    )}

    {registerBoatModal && (
      <RegisterBoatModalContent toggleModal={toggleBoatModal} />
    )}

    {registerAnglerModal && (
      <RegisterAnglerModalContent toggleModal={toggleAnglerModal} />
    )}

    <button className="btn-register" onClick={toggleTeamModal} disabled={true}>Register Team</button>
    <button className="btn-register" onClick={toggleBoatModal}>Register Boat</button>
    <button className="btn-register" onClick={toggleAnglerModal}>Register Angler</button>
    <br/>
    <br/>

    <AdminRegistrationTabs/>
  </>
}

export default AdminRegister;

